import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";
import { useApiClient } from "../../../shared/customHooks";
import { providingInclusiveKindergartenEnvironmentForm } from "../../../shared/formObjects/application/providingInclusiveKindergartenEnvironmentForm";
import { useApplicationContext } from "../context/applicationContext";

function ProvidingInclusiveKindergartenEnvironmentComponent({ disabled, data }: any) {
  const api = useApiClient("ProvidingInclusiveKindergartenEnvironment");
  const { id } = useApplicationContext();

  return (
    <BaseApplicationComponent
      formBody={providingInclusiveKindergartenEnvironmentForm}
      headerLabel="Providing an inclusive Kindergarten Environment"
      editPath="providingInclusiveKindergartenEnvironment"
      apiClient={api}
      disabled={disabled}
      data={data}
      id={id}
      showInternalNotes={false}
      print={true}
    />
  );
}

export default ProvidingInclusiveKindergartenEnvironmentComponent;
